// extracted by mini-css-extract-plugin
export default {"wrapper":"k1-z","play":"l1-z"};